/**
 * 配置管理内容区域组件
 */
import React from 'react';
import { Alert, Card, Space, Select, Button, App } from 'antd';
import { WeightSystemConfig, PresetListItem } from '../../../services/configPresetAPI';
import { METRIC_DIMENSIONS, getIconComponent } from '../constants/componentLabels';
import { MetricConfigPanel } from './MetricConfigPanel';
import { FBAFeeConfig } from './FBAFeeConfig';
import { ConfigStructureOverview } from './ConfigStructureOverview';
import { PresetComparison } from './PresetComparison';
import { GlobalAIConfig } from './GlobalAIConfig';

const { Option } = Select;

interface ConfigContentProps {
    selectedKey: string;
    currentConfig: WeightSystemConfig | null;
    presets: PresetListItem[];
    isStandalone: boolean;
    onConfigChange: (metricKey: string, newConfig: any) => void;
    onApplyPreset: (metricKey: string, presetKey: string) => void;
}

export const ConfigContent: React.FC<ConfigContentProps> = ({
    selectedKey,
    currentConfig,
    presets,
    isStandalone,
    onConfigChange,
    onApplyPreset
}) => {
    const { message } = App.useApp();

    const handleSaveMetricToSKU = async (metricKey: string) => {
        // TODO: 实现保存逻辑
        message.success('该指标配置已保存到SKU');
    };

    // 1. 评分模型配置
    const metricDimension = METRIC_DIMENSIONS.find(d => d.key === selectedKey);
    if (metricDimension) {
        return (
            <Card
                title={
                    <div className="dimension-header">
                        <div className="dimension-title" style={{ color: metricDimension.color }}>
                            {getIconComponent(metricDimension.iconType)} {metricDimension.label}
                        </div>
                        <div className="dimension-desc">{metricDimension.description}</div>
                    </div>
                }
                extra={
                    !isStandalone && (
                        <Space>
                            <Select
                                style={{ width: 200 }}
                                placeholder="选择预设策略"
                                onChange={(presetKey) => onApplyPreset(metricDimension.key, presetKey)}
                            >
                                {presets.map((preset) => (
                                    <Option key={preset.key} value={preset.key}>
                                        {preset.name}
                                    </Option>
                                ))}
                            </Select>
                            <Button
                                type="primary"
                                size="small"
                                onClick={() => handleSaveMetricToSKU(metricDimension.key)}
                            >
                                应用到当前SKU
                            </Button>
                        </Space>
                    )
                }
                bordered={false}
            >
                {currentConfig && currentConfig[metricDimension.key as keyof WeightSystemConfig] ? (
                    <MetricConfigPanel
                        metricKey={metricDimension.key}
                        metricConfig={currentConfig[metricDimension.key as keyof WeightSystemConfig] as any}
                        onChange={(newConfig) => onConfigChange(metricDimension.key, newConfig)}
                        color={metricDimension.color}
                    />
                ) : (
                    <Alert message="该指标配置不存在" type="warning" />
                )}
            </Card>
        );
    }

    // 2. FBA费率配置
    if (selectedKey === 'fba-fees') {
        return <FBAFeeConfig />;
    }

    // 3. 系统配置
    if (selectedKey === 'structure-overview') {
        return <ConfigStructureOverview config={currentConfig} />;
    }
    if (selectedKey === 'comparison') {
        return <PresetComparison presets={presets} />;
    }
    if (selectedKey === 'global-ai-config') {
        return isStandalone ? <GlobalAIConfig /> : <Alert message="全局AI配置仅在配置中心主页可用" type="info" />;
    }

    return <Alert message="请选择左侧菜单项" type="info" />;
};
